// Module
var code = "<iframe src=\"{{src}}\" id=\"{{id}}\" class=\"{{class}}\" scrolling=\"{{scrolling}}\"></iframe> ";
// Exports
export default code;